import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddinstoreComponent } from './addinstore/addinstore.component';
import { ReactiveFormsModule } from '@angular/forms';
import {​​​​​​​​ MatDatepickerModule }​​​​​​​​ from'@angular/material/datepicker';
import {​​​​​​​​ MatInputModule }​​​​​​​​ from'@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from "ngx-spinner";
import { ConfirmDialogModule } from '@app/module/confirm-dialog/confirm-dialog.module';

@NgModule({
  declarations: [AddinstoreComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    NgbModule,ConfirmDialogModule,
    NgxSpinnerModule
  ]
})
export class AddinstoreModule { }
